import BlankLayout from "../components/BlankLayout";
import DefaultLayout from "../components/DefaultLayout";
import { routes } from "./routes";

const finalRoutes = routes.map((route) => ({
  ...route,
  element:
    route.layout === "blank" ? (
      <BlankLayout>{route.element}</BlankLayout>
    ) : (
      <DefaultLayout>{route.element}</DefaultLayout>
    ),
}));

const router = finalRoutes;

export default router;
